const content = `
<p>
  <strong>
    请您在提交实物鉴别前仔细谨慎阅读以下实物鉴别须知，并确保您在完全知情并接受本须知的情况下使用实物鉴别服务。如您不同意或不理解本须知任何内容，请您停止申请实物鉴别服务。如您使用实物鉴别服务，则视为您认可并同意本须知的全部内容。
  </strong>
</p>
<p>
  <br>
</p>
<p>
  一、鉴别申请及实物邮寄
</p>
<p>
  <br>
</p>
<p>
  1、用户申请实物鉴别需准确上传待鉴别实物的品类、品牌、正面图片等商品信息。若到货商品与上传商品信息不符，图灵鉴定有权拒收并退回商品。同时，图灵鉴定所收取的实物鉴别服务费不予退还，过程中所产生的费用均由用户自行承担；
</p>
<p>
  <br>
</p>
<p>
  2、实物鉴别用户需自行承担寄出快递费用，并通过顺丰速运寄送商品至图灵鉴定中心（拒收到付件），贵重商品建议用户寄件时进行保价。因商品是邮寄而来，邮寄过程可能存在污染，进而影响鉴别结果，这是无法避免的。我方收到包裹如发现异常，会及时联系您。
</p>
<p>
  <br>
</p>
<p>
  二、实物鉴别
</p>
<p>
  <br>
</p>
<p>
  1、用户申请进行实物鉴别的商品，应确保包装完好寄出；
</p>
<p>
  <br>
</p>
<p>
  2、图灵鉴定中心签收实物后72小时内给予最终鉴别结果，如遇法定节假日或不可抗力因素，实物鉴别时间会根据相应情况自然顺延，具体情况和延迟时间可咨询图灵鉴定在线客服。
</p>
<p>
  <br>
</p>
<p>
  3、实物鉴别并非行政或司法意义上的鉴定，鉴别结果仅供用户参考，未经图灵鉴定允许，严禁其他用途；
</p>
<p>
  <br>
</p>
<p>
  三、鉴别结果及其他
</p>
<p>
  <br>
</p>
<p>
  1．用户在收到寄回商品后请对商品及包装的完好性进行确认后再行签收，若包装存在破损或商品受到损坏，用户有权拒收并向快递公司主张权利。
</p>
<p>
  <br>
</p>
<p>
  2、若用户对实物鉴别结果有异议，请于七日内与客服联系，并提供相应资料以及国家法律机构认定的鉴别报告，供平台做进一步确认。若经证实，实物鉴别结果有误的，平台将退还用户支付的鉴别服务费，并赔偿双倍鉴别服务费。但请您理解，平台无法就您的其他额外损失承担赔偿责任。
</p>
<p>
  <br>
</p>
<p>
  3、实物鉴别会由于特殊因素导致无法给出结论的情况，若出现该情况，图灵鉴定将及时与用户联系，并为您进行退费处理。
</p>
<p>
  <br>
</p>
<p>
  4、实物鉴别完成后，将按用户填写回寄地址寄回，若用户拒收，产生的额外邮费将由用户自主承担。若实物鉴别完成，寄回用户后遭遇拒收的商品再寄送回图灵鉴定，用户需在30日内联系图灵鉴定处理，若超时图灵鉴定视为用户放弃货物所有权，将由图灵鉴定自行对货物进行处理。
</p>
<p>
  <br>
</p>
<p>
  5、本须知由图灵鉴定公司制定并公示，公司有权对本须知进行不时地调整与修改，如您对须知存在疑问，请联系客服进行咨询；
</p>

`
export default {
  content,
  title: '图灵线下实物鉴别协议'
}
